<ras-page>
	<main>
		<h1>Privacy statement</h1>

		<p class="lead">Rent-A-Store respects your privacy. This Privacy Statement informs you of our privacy practices.</p>

		<p>No personal information will be disclosed, shared or sold by Rent-A-Store without the express written permission of the user, unless Rent-A-Store is permitted or required to do so by law.</p>

		<p><a href="/downloads/M0153 Privacy Policy final.pdf" target="_blank">Download Privacy Statement</a> (PDF 133kb)</p>
	</main>
</ras-page>
